<!--
 * @Author: hucaili 735856642@qq.com
 * @Date: 2023-06-09 11:26:17
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2024-02-07 11:49:55
 * @FilePath: \fe-crm\src\components\public\xl-cooperation\management\management.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="cooperation-list">
    <jw-modal class="cooperation-modal" :visible="visible" :title="title" @cancel="handleCancel" title-align="start" @ok="handleOk" width="720px" :mask-closable="false" :footer="edit ? true : false">
      <div v-if="!edit" style="display: flex; justify-content: end; margin: -5px 0 10px 0">
        <jw-button type="primary" v-if="userInfo?.roles?.indexOf(permissionList[type]) !== -1 && buttons.indexOf(permissionList[type]) > -1" size="small" @click="addCooperation" style="margin-right: 10px">{{ $t('新增') }}</jw-button>
        <jw-button v-if="userInfo?.roles?.indexOf(managePermissionList[type]) !== -1 && buttons.indexOf(managePermissionList[type]) > -1 && list" size="small" @click="editCooperation">{{ $t('编辑') }}</jw-button>
      </div>
      <jw-space direction="vertical" fill>
        <div v-if="cooperationID?.length > 0 && edit && userInfo?.roles?.indexOf(managePermissionList[type]) !== -1 && buttons.indexOf(managePermissionList[type]) > -1" class="batch-cooperation">
          <!-- <span>已选择{{ cooperationID.length }}条</span> -->
          <jw-button type="outline" @click="cooperationBatch" style="margin-left: 20px"> {{ $t('批量删除') }} </jw-button>
        </div>
      </jw-space>

      <jw-table :scroll="scrollPercent" sticky-header :pagination="pagination" row-key="id" v-model:selectedKeys="cooperationID" :bordered="false" :data="list" :loading="loading" @pageChange="pageChange" ref="xlUserTable" :columns="columns" :row-selection="edit ? rowSelection : null" @select="xlUseSelect" @selectAll="xlUseSelectAll">
        <template #collaboratorName="{ record }">
          <xl-avatar v-if="record.collaboratorName" :avatar="{ id: record.collaboratorId, name: record.collaboratorName, url: record.collaboratorAvatar }" :size="22" />
        </template>
        <template #operate="{ record }" v-if="edit">
          <jw-button size="small" @click="remove(record.id)" v-if="record.collaboratorType != 1">{{ $t('删除') }}</jw-button>
        </template>
        <template #permission="{ record }">
          <template v-if="edit">
            <jw-radio-group v-if="record.collaboratorType != 1" v-model="record.permission" @change="cooperationChange">
              <jw-radio v-for="item in cooperationOptions" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
            </jw-radio-group>
            <template v-else>
              {{ record.permission == '1' ? $t('读写') : $t('只读') }}
            </template>
          </template>
          <template v-else>
            {{ record.permission == '1' ? $t('读写') : $t('只读') }}
          </template>
        </template>
        <template #collaboratorType="{ record }">
          <span>{{ record.collaboratorType == '1' ? $t('负责人') : record.collaboratorType == '2' ? $t('协作人') : record.collaboratorType == '3' ? $t('业绩参与人') : '-' }}</span>
        </template>
      </jw-table>
      <template #footer>
        <template v-if="edit">
          <jw-button @click="updateCancel">{{ $t('取消') }}</jw-button>
          <jw-button type="primary" @click="handleOk" :loading="loading">{{ $t('确定') }}</jw-button>
        </template>
      </template>
    </jw-modal>
    <!-- // 新增编辑 -->
    <update-cooperation ref="updateRef" @cb="getCollaborator"></update-cooperation>
  </div>
</template>
<script>
import { reactive, toRefs, ref, inject, watch } from 'vue';
import { clientService } from '@/api/';
import useLoading from '@/hooks/loading';
import { Message } from '@arco-design/web-vue';
import UpdateCooperation from '../update-cooperation/update-cooperation.vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/store';
export default {
  name: 'CooperationList',
  components: {
    UpdateCooperation
  },
  setup(props, ctx) {
    const { t } = useI18n();
    const { loading, setLoading } = useLoading(false);
    const { userInfo } = useUserStore(); //用户信息
    const data = reactive({
      visible: false,
      title: t('管理协作人'),
      edit: false,
      cooperationID: [],
      rowSelection: {
        type: 'checkbox',
        showCheckedAll: true
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        model: 1,
        showPageSize: false, // 是否显示数据条数选择器
        pageSizeOptions: [10, 20, 30, 40, 50, 100],
        showTotal: true // 是否显示数据总数
      },
      id: inject('detailParams').id, //客户id,
      type: inject('detailParams').entity,
      list: [],
      page: 1,
      buttons: [],
      permissionList: { 1: 'clue:addCollaborator', 2: 'customer:addCollaborator', 3: 'businessOpportunity:addCollaborator', 6: 'priceSheet:addCollaborator', 8: 'contract:addCollaborator', 10: 'saleOrder:addCollaborator', 12: 'afterSale:addCollaborator', 13: 'returnOrder:addCollaborator' },
      managePermissionList: { 1: 'clue:manageCollaborator', 2: 'customer:manageCollaborator', 3: 'businessOpportunity:manageCollaborator', 6: 'priceSheet:manageCollaborator', 8: 'contract:manageCollaborator', 10: 'saleOrder:manageCollaborator', 12: 'afterSale:manageCollaborator', 13: 'returnOrder:manageCollaborator' }
    });
    const cooperationOptions = reactive([
      { value: 1, label: t('读写') },
      { value: 2, label: t('只读') }
    ]);
    // 新增/编辑实例
    const scrollPercent = {
      y: 300
    };
    const updateRef = ref();
    const open = (buttons = []) => {
      data.buttons = buttons; //操作按钮的权限
      data.edit = false;
      data.visible = true;
      if (data.type >= 200) {
        //自定义对象追加动态权限
        data.permissionList[data.type] = `${data.type}:addCollaborator`;
        data.managePermissionList[data.type] = `${data.type}:manageCollaborator`;
      }
      getCollaborator();
    };
    const handleCancel = () => {
      data.visible = false;
      ctx.emit('cb');
    };
    const updateCancel = () => {
      columns[3].width = 80;
      if (data.edit) {
        data.edit = false;
        columns.map((item, index) => {
          if (item.dataIndex == 'operate') {
            columns.splice(index, 1);
          }
        });
        data.cooperationID = [];
        getCollaborator();
        return;
      }
      data.visible = false;
      ctx.emit('cb');
    };
    const handleOk = () => {
      updateCollaborator();
    };
    //分页
    const pageChange = (current) => {
      console.log(86, current);
      data.page = current;
      data.pagination.current = current;
      getCollaborator();
    };
    //获取协作人列表
    const getCollaborator = async () => {
      setLoading(true);
      const params = {
        businessId: data.id,
        type: data.type,
        page: data.page,
        pageSize: 10
      };
      console.log(params);
      data.list = [];
      try {
        const res = await clientService.getCollaborator(params);
        setLoading(false);
        console.log(res);
        if (res.error) {
          Message.error(res.error?.msg || t('协作人查询异常'));
          return;
        }
        data.list = res.result?.records;
        data.pagination.total = res.result?.total;
      } catch (e) {
        setLoading(false);
        Message.error(e.message || e.statusText || t('协作人查询异常'));
      }
    };
    const columns = reactive([
      {
        title: t('姓名'),
        dataIndex: 'collaboratorName',
        slotName: 'collaboratorName',
        ellipsis: true,
        tooltip: true,
        width: 100
      },
      {
        title: t('部门'),
        dataIndex: 'departmentName',
        ellipsis: true,
        tooltip: true,
        width: 100
      },
      {
        title: t('角色'),
        dataIndex: 'collaboratorType',
        slotName: 'collaboratorType',
        width: 80
      },
      {
        title: t('权限'),
        dataIndex: 'permission',
        slotName: 'permission',
        width: 80
      }
    ]);
    // 新增
    const addCooperation = () => {
      updateRef.value.open();
    };
    // 编辑
    const editCooperation = () => {
      const haveData = columns.filter((el) => el.dataIndex === 'operate');
      columns[3].width = 160;
      if (!haveData.length) {
        columns.push({
          title: t('操作'),
          dataIndex: 'operate',
          slotName: 'operate',
          width: 80
        });
      }
      data.edit = !data.edit;
      console.log(haveData);
    };
    watch(
      () => data.edit,
      (v) => {
        if (v) {
          console.log(v);
          data.list?.map((item) => {
            if (item.collaboratorType && item.collaboratorType == 1) {
              item.disabled = true;
            }
          });
        }
      },
      {
        deep: true
      }
    );
    //编辑权限
    const cooperationChange = (value) => {
      console.log(value);
    };
    //批量删除
    const cooperationBatch = () => {
      data.list = data.list?.filter(function (item1) {
        return data.cooperationID.every(function (item2) {
          return item2 !== item1.id;
        });
      });
      console.log(data.list);
    };
    //批量删除--全选
    const xlUseSelectAll = (checked) => {
      console.log('批量转移rowKeys', checked);
      data.cooperationID = [];
      if (checked) {
        data.list?.map((item) => {
          data.cooperationID.push(item.id);
        });
      }
      console.log(data.cooperationID);
    };
    //xlUseSelect-单选
    const xlUseSelect = (rowKeys, rowKey, record) => {
      console.log('批量转移rowKeys', rowKeys, rowKey, record);
      if (data.cooperationID.indexOf(record.id) == -1) {
        data.cooperationID.push(record.id);
      } else {
        data.cooperationID?.map((item, index) => {
          if (item == record.id) {
            data.cooperationID?.splice(index, 1);
          }
        });
      }
    };
    //删除
    const remove = (id) => {
      data.list?.map((item, index) => {
        if (item.id == id) {
          data.list?.splice(index, 1);
        }
      });
    };
    // 编辑协作人
    const updateCollaborator = async () => {
      const list = [];
      data.list.map((item) => {
        list.push({ id: item.id, permission: item.permission });
      });
      const params = {
        businessId: data.id,
        type: data.type,
        list: list
      };
      try {
        const res = await clientService.updateCollaborator(params);
        console.log(res);
        if (res.error) {
          Message.error(res.error?.msg || t('编辑失败'));
          return;
        }
        Message.success(t('操作成功'));
        columns.map((item, index) => {
          if (item.dataIndex == 'operate') {
            columns.splice(index, 1);
          }
        });
        getCollaborator(); //刷新列表
        data.edit = false;
      } catch (e) {
        Message.error(e.message || e.statusText || t('编辑协作人失败'));
      }
    };
    return {
      open,
      getCollaborator,
      handleCancel,
      updateCancel,
      handleOk,
      remove,
      columns,
      loading,
      pageChange,
      cooperationOptions,
      addCooperation,
      updateRef,
      UpdateCooperation,
      updateCollaborator,
      editCooperation,
      cooperationChange,
      cooperationBatch,
      xlUseSelectAll,
      xlUseSelect,
      userInfo,
      scrollPercent,
      ...toRefs(data)
    };
  }
};
</script>

<style lang="less">
@import './management.less';
</style>
